export const STORE_NAVIGATION = Object.freeze([
  { label: 'All Products', to: '/shop' },
  { label: 'Crochet', to: '/shop?category=crochet' },
  { label: 'Gifts', to: '/shop?category=gifts' },
  { label: 'Custom orders', to: '/custom-orders' },
  { label: 'Reviews', to: '/reviews' },
  { label: 'About us', to: '/about' },
]);
